export default __webpack_public_path__ + "static/generator_b.413729dcc3d61cfa5b313272f5909726.svg";